import React from "react"
import PropTypes from "prop-types"

import MainPageSkeleton from "../Skeleton/MainPageSkeleton"
import InvoicesSkeleton from "../Skeleton/InvoicesSkeleton"
import ProductsPlantSkeleton from "../Skeleton/ProductsPlantSkeleton"
import FixedVoiceSkeleton from "../Skeleton/FixedVoiceSkeleton"
import IncidentManagerSkeleton from "../Skeleton/IncidentManagerSkeleton"
import TicketManagerSkeleton from "../Skeleton/TicketManagerSkeleton"
import DetailingPosPreControleSkeleton from "../Skeleton/DetailingPosPreControleSkeleton"
import TrafficPreControleSkeleton from "../Skeleton/TrafficPreControleSkeleton"
import DatatrafficSkeleton from "../Skeleton/DataTrafficSkeleton"
import NegotiationSkeleton from "../Skeleton/NegotiationSkeleton"
import OpenInvoicesSkeleton from "../Skeleton/OpenInvoicesSkeleton"
import AutomaticDebitSkeleton from "../Skeleton/AutomaticDebitSkeleton"
import OnlineInterfaceDebitSkeleton from "../Skeleton/OnlineInterfaceSkeleton"
import FormDebitSkeleton from "../Skeleton/AutomaticDebitSkeleton/FormSkeleton"
import ActiveSkeleton from "../Skeleton/AutomaticDebitSkeleton/ActiveSkeleton"
import SelectNumberSkeleton from "components/Skeleton/DetailingPosPreControleSkeleton/SelectNumberSkeleton"
import DataTrafficSkeletonDetails from "../Skeleton/DataTrafficSkeleton/DetailsSkeleton"
import HistorySkeleton from "../Skeleton/NegotiationSkeleton/HistorySkeleton"
import ScheduleSkeleton from "../Skeleton/ScheduleSkeleton/index"
import Table from "../Skeleton/IncidentManagerSkeleton/Table"
import ProductsContractsSkeleton from "../Skeleton/ProductsContractsSkeleton"
import ContractsAndOrdersSkeleton from "../Skeleton/ContractsAndOrdersSkeleton"
import OrdersTermSkeleton from "../Skeleton/OrdersTermSkeleton/index"
import CardsOtherServicesSkeleton from "../Skeleton/CardsOtherServicesSkeleton/index"
import ManagerOnlineInterfaceSkeleton from "../Skeleton/ManagerOnlineInterfaceSkeleton"
import HistoryOnlineInterfaceSkeleton from "../Skeleton/HistoryOnlineInterfaceSkeleton"
import NoScheduleOnlineInterfaceSkeleton from "../Skeleton/NoScheduleOnlineInterfaceSkeleton"
import ScheduleOnlineInterfaceSkeleton from "../Skeleton/ScheduleOnlineInterfaceSkeleton"
import MenuNavegationSkeleton from "../Skeleton/MenuNavegationSkeleton"
import SharedDataSkeleton from "../Skeleton/SharedDataSkeleton"
import InvoicesSummarySkeleton from "../Skeleton/InvoicesSummarySkeleton"

const skeletonComponents = {
  "/invoices": InvoicesSkeleton,
  "/invoices/": InvoicesSkeleton,
  "/products-plant": ProductsPlantSkeleton,
  "/fixed-voice": FixedVoiceSkeleton,
  "/incident-manager": IncidentManagerSkeleton,
  "/tickets": TicketManagerSkeleton,
  "/detailing-pos-pre-controle": DetailingPosPreControleSkeleton,
  "/traffic-pre-controle": TrafficPreControleSkeleton,
  "/data-traffic": DatatrafficSkeleton,
  "/negotiation": NegotiationSkeleton,
  openInvoices: OpenInvoicesSkeleton,
  "/automatic-debit": AutomaticDebitSkeleton,
  "/interface-online": OnlineInterfaceDebitSkeleton,
  formDebit: FormDebitSkeleton,
  activeDebit: ActiveSkeleton,
  selectNumberDetailing: SelectNumberSkeleton,
  detailTraffic: DataTrafficSkeletonDetails,
  history: HistorySkeleton,
  schedule: ScheduleSkeleton,
  tableProtocol: Table,
  productsContracts: ProductsContractsSkeleton,
  "/contracts-and-orders": ContractsAndOrdersSkeleton,
  ordersTerm: OrdersTermSkeleton,
  cardsOtherServices: CardsOtherServicesSkeleton,
  managerOnlineInterface: ManagerOnlineInterfaceSkeleton,
  historyOnlineInterface: HistoryOnlineInterfaceSkeleton,
  noScheduleOnlineInterface: NoScheduleOnlineInterfaceSkeleton,
  scheduleOnlineInterface: ScheduleOnlineInterfaceSkeleton,
  menuNavegation: MenuNavegationSkeleton,
  sharedData: SharedDataSkeleton,
  invoicesSummary: InvoicesSummarySkeleton
}

const WrapperSkeleton = ({ path, isChildrenReady, children }) => {
  if (isChildrenReady) return children

  const SkeletonComponent = skeletonComponents[path] || MainPageSkeleton
  return <SkeletonComponent />
}

WrapperSkeleton.propTypes = {
  path: PropTypes.string,
  isChildrenReady: PropTypes.bool,
  children: PropTypes.node
}

export default WrapperSkeleton



// WEBPACK FOOTER //
// ./src/components/WrapperSkeleton/index.js